import { Modal } from 'antd';

import type * as T from './type';

function PushResultModal(props: T.PushResultModalProps) {
  return (
    <Modal {...props} open={true}>
      <div>gd</div>
    </Modal>
  );
}

export default PushResultModal;
